<template>

  <div class="page-title">
    <div class="title">
      <h5><point-status :status="job.status"></point-status> {{ job.title }} <small>#{{ job.code }}</small></h5>
      <h6>
        <strong
          :class="job.status === 'open' ? 'text-success' : 'text-secondary'">
          {{ statusName }}
        </strong> - 
        {{ job.hiring_manager_name }},
        {{ departamentName }}<span class="hide-less-sm">,
        {{ companyName }},
        {{ $tc('n_openings', job.openings, {count: job.openings}) }} -
        {{ $d(new Date(job.date_open), 'short') }}</span>
      </h6>
    </div>
    <div class="btn-row">
      <JobFollow />
      <JobPublish />
      <Deadline
        class="hide-less-sm"
        :value="job.deadline" />
      <JobOptions />
    </div>
  </div>

</template>

<script>
import Deadline from '@/components/Parts/Deadline'
import PointStatus from '@/components/Parts/PointStatus'
import JobOptions from './JobOptions'
import JobFollow from './JobFollow'
import JobPublish from './JobPublish'

export default {
  name: 'JobHeader',
  components: {
    Deadline,
    PointStatus,
    JobOptions,
    JobFollow,
    JobPublish
  },
  props: [
  ],
  data () {
    return {
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    },
    companyName () {
      return this.job.company_id ? this.job.company_id.name : null
    },
    departamentName () {
      return this.job.departament_id ? this.job.departament_id.name : null
    },
    statusName () {
      return {
        open: this.$t('Open'),
        archived: this.$t('Archived')
      }[this.job.status]
    },
    openingsUnfilled () {
      return this.job.openings - this.job.pipeline.hired
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobHeader/JobHeader.vue